// Toolbar item (`<li>`) width in pixels
export var TOOLBAR_ITEM_WIDTH = 100;
export var TOOLBAR_HEIGHT = 43;
